if (!customElements.get('rocket-product-card-image-slider')) {
  customElements.define(
    'rocket-product-card-image-slider',
    class RocketProductCardImageSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderWrapper = this.querySelector('.swiper');
        this.sliderPagination = this.querySelector('.swiper-pagination');
        this.sliderInstance = null;
      }

      connectedCallback() {
        if (!this.sliderWrapper || !window.FoxTheme?.Carousel) return;
        this.initSlider();
      }

      initSlider() {
        this.sliderOptions = {
          slidesPerView: 1,
          pagination: {
            el: this.sliderPagination,  
            clickable: true,
          },
          threshold: 2,
          on: {
            init: this.handleSliderInit?.bind(this),
            slideChange: this.handleSlideChange.bind(this),
          },
        };
        this.sliderInstance = new window.FoxTheme.Carousel(
          this.sliderWrapper,
          this.sliderOptions,
          [
            FoxTheme.Swiper.EffectFade,
            FoxTheme.Swiper.Autoplay
          ]
        );
        this.sliderInstance.init();
      }

      handleSlideChange() {
        const swiper = this.sliderInstance?.slider;
        if (!swiper) return;
      
        const activeIndex = swiper.activeIndex;
      
        const activeSlide = this.sliderWrapper.querySelectorAll('.swiper-slide')[activeIndex];
        const thumbUrl = activeSlide?.dataset.thumb;
      
        if (!thumbUrl) return;
      
        const productCard = this.closest('.product-card');
        const swatch = productCard?.querySelector('swatch-color-element');
      
        if (!swatch) return;
      
        swatch.querySelectorAll('li').forEach((el) => {
          if (el.dataset.thumb === thumbUrl || el.dataset.thumbHover === thumbUrl || el.dataset.thumbList.includes(thumbUrl)) {
            el.classList.add('active');
          } else {
            el.classList.remove('active');
          }
        });
      }

      scrollToImageByThumb(thumbUrl) {
        if (!this.sliderInstance || !thumbUrl) return;
      
        const slides = this.sliderWrapper.querySelectorAll('.swiper-slide');
        let targetIndex = -1;

        slides.forEach((slide, index) => {
          if (slide.dataset.thumb === thumbUrl) {
            targetIndex = index;
          }
        });

        if (targetIndex !== -1) {
          this.sliderInstance.slider.slideTo(targetIndex);
        }
      }
      
    }
  );
}

window.scrollToProductSliderImage = (thumbUrl, container = document) => {
  const slider = container.querySelector('rocket-product-card-image-slider');
  if (slider && typeof slider.scrollToImageByThumb === 'function') {
    slider.scrollToImageByThumb(thumbUrl);
  }
};
